import React from 'react';
import { KBBlock } from '../../../types';

interface Props {
  block: KBBlock;
  isEditing: boolean;
  onChange: (updates: Partial<KBBlock>) => void;
  onFinish: () => void;
}

const SIZES: { label: string; value: number; px: number }[] = [
  { label: 'Small', value: 1, px: 24 },
  { label: 'Medium', value: 2, px: 48 },
  { label: 'Large', value: 3, px: 80 },
  { label: 'XL', value: 4, px: 128 },
];

const SpacerBlock: React.FC<Props> = ({ block, isEditing, onChange, onFinish }) => {
  const size: number = block.data?.size ?? 2;
  const entry = SIZES.find((s) => s.value === size) ?? SIZES[1];

  if (isEditing) {
    return (
      <div className="flex items-center gap-3 py-2">
        <span className="text-xs text-gray-400">Spacer height:</span>
        <div className="flex gap-2">
          {SIZES.map((s) => (
            <button
              key={s.value}
              onClick={() => onChange({ data: { ...block.data, size: s.value } })}
              className={`text-xs px-3 py-1 rounded border ${size === s.value ? 'bg-blue-600 text-white border-blue-600' : 'border-gray-200 text-gray-600 hover:border-blue-300'}`}
            >
              {s.label}
            </button>
          ))}
        </div>
        <button onClick={onFinish} className="ml-auto text-xs text-gray-400 hover:text-gray-600">Done</button>
      </div>
    );
  }

  return <div style={{ height: entry.px }} />;
};

export default SpacerBlock;
